export default __webpack_public_path__ + "static/media/CountryIcon.674f52f7.svg";